// How shops reach us (subscriptions while online payment isn't live, and help).
export const SUPPORT_EMAIL = 'support@sanogodam.com'
export const SUPPORT_PHONE = '+9779805676345'
export const SUPPORT_PHONE_LABEL = '+977 980-5676345'

/** A mailto: link with the subject and body filled in. */
export function supportMailto(subject: string, body: string): string {
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}

export const supportTel = `tel:${SUPPORT_PHONE}`
